import React, { useState } from "react";
import { Blurhash } from "react-blurhash";

const TopicBlurhashImage = ({ src, alt, className, hash }) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <div className="topic-blurhash-wrapper">
      {!imageLoaded && (
        <Blurhash
          hash={hash}
          width="100%"
          height="300px"
          resolutionX={32}
          resolutionY={32}
          punch={1}
        />
      )}
      <img
        src={src}
        alt={alt}
        className={`responsive-image ${
          imageLoaded ? "visible" : "hidden"
        } topic-image-spacing`}
        onLoad={() => setImageLoaded(true)}
      />
    </div>
  );
};

export default TopicBlurhashImage;
